var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import 'intersection-observer';
import * as dayjs from 'dayjs';
import css from './style.pcss';
var RTLLivestreamSchedule = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLLivestreamSchedule, _LitElement);
  function RTLLivestreamSchedule() {
    var _this;
    _classCallCheck(this, RTLLivestreamSchedule);
    _this = _callSuper(this, RTLLivestreamSchedule);
    _this.planning = [];
    _this.apiLocation = "https://www.rtl.lu";
    _this.site = 'rtl';
    _this.displayDate = null;
    if (window.rtlsites) {
      _this.site = window.rtlsites.config.site;
    }
    if (process.env.NODE_ENV == 'development') {
      _this.location = "http://localhost:8080";
    }
    return _this;
  }
  _createClass(RTLLivestreamSchedule, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      //console.log(this.singleDay, this.types, this.startDate, this.endDate);
      _get(_getPrototypeOf(RTLLivestreamSchedule.prototype), "connectedCallback", this).call(this);
      if (this.startDate) {
        this.startDate = new dayjs(this.startDate);
      } else {
        this.startDate = new dayjs();
      }
      if (this.endDate) {
        this.endDate = new dayjs(this.endDate);
      } else {
        this.endDate = this.startDate;
      }
      if (this.singleDay) {
        this.displayDate = this.startDate;
      }
      this._fetchData(this.startDate, this.endDate, this.site);
    }
  }, {
    key: "_fetchData",
    value: function _fetchData(startDate, endDate, site) {
      var _this2 = this;
      if (!endDate) {
        endDate = startDate;
      }
      var types = this.types ? this.types : "";
      this._apiUrl = `${this.apiLocation}/api/livestream-planning?start_date=${startDate.format("YYYY-MM-DD")}&end_date=${endDate.format("YYYY-MM-DD")}&types=${window.encodeURI(types)}&site=${site}`;
      fetch(this._apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        //console.log(resp);
        _this2.planning = resp;
      });
    }
  }, {
    key: "renderPlanningOneDay",
    value: function renderPlanningOneDay(day, dayPlanning) {
      if (this.singleDay && day !== this.displayDate.format("YYYY-MM-DD")) {
        return;
      }
      var ret = [];
      dayPlanning.forEach(function (entry) {
        ret.push(html(_t || (_t = _`<div style="border:1px solid black;">
                                ${0} - ${0}
                                ${0}
                                <div>${0}</div>
                                ${0}
                          </div>`), entry.from, entry.to, entry.name, entry.description, entry.online ? html(_t2 || (_t2 = _`online`)) : null));
      });
      return html(_t3 || (_t3 = _`<div>
                    <div style="width:100%;border:1px solid;background-color:gray">
                        ${0}
                    </div>
                    ${0}
                </div>`), new dayjs(day).format("DD.MM.YYYY"), ret);
    }
  }, {
    key: "renderNavButtons",
    value: function renderNavButtons() {
      var _this3 = this;
      if (!this.singleDay) {
        return;
      }
      var previousDay = this.displayDate.add(-1, 'day');
      var nextDay = this.displayDate.add(1, 'day');
      var canGoPrevious = true;
      if (previousDay.isBefore(this.startDate, 'day')) {
        previousDay = this.startDate;
        canGoPrevious = false;
      }
      var canGoNext = true;
      if (nextDay.isAfter(this.endDate, 'day')) {
        nextDay = this.endDate;
        canGoNext = false;
      }
      return html(_t4 || (_t4 = _`<div>
                        <span @click=${0}>Prev</span>
                        <span @click=${0}>Next</span>
                    </div>`), function () {
        return _this3.displayDate = previousDay;
      }, function () {
        return _this3.displayDate = nextDay;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return html(_t5 || (_t5 = _`
            <style>${0}</style>
            ${0}
            <div style="border:1px solid;">
                ${0}
            </div>
        `), css, this.renderNavButtons(), Object.keys(this.planning).map(function (day) {
        var dayPlanning = _this4.planning[day];
        return html(_t6 || (_t6 = _`<div>
                                        ${0}
                                </div>`), _this4.renderPlanningOneDay(day, dayPlanning));
      }));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        types: {
          type: String
        },
        planning: {
          type: Array,
          attribute: false
        },
        startDate: {
          type: String
        },
        endDate: {
          type: String
        },
        singleDay: {
          type: Boolean
        },
        displayDate: {
          type: Object,
          attribute: false
        },
        site: {
          type: String
        }
      };
    }
  }]);
  return RTLLivestreamSchedule;
}(LitElement);
export { RTLLivestreamSchedule as default };
window.customElements.define('rtl-livestream-schedule', RTLLivestreamSchedule);